import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import media1 from "../assets/MediaAboutImage1.jpg";
import media2 from "../assets/MediaAboutImage2.jpg";
import HeaderComponent from "./HeaderComponent";

const MediaAbout = ({ showHeader = true }) => {
  const controls1 = useAnimation();
  const controls2 = useAnimation();

  const [ref1, inView1] = useInView({ threshold: 0.1 });
  const [ref2, inView2] = useInView({ threshold: 0.1 });

  useEffect(() => {
    controls1.start(inView1 ? "visible" : "hidden");
    controls2.start(inView2 ? "visible" : "hidden");
  }, [inView1, inView2]);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const contentVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  return (
    <>
      {showHeader && <HeaderComponent />}

      <div className="px-6 py-16 flex flex-col items-center gap-12">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-[#F63A0A] text-white px-6 py-2 rounded-xl text-lg sm:text-xl md:text-2xl font-semibold"
        >
          What the Media Say About Us
        </motion.h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 w-full max-w-4xl justify-center">
          {/* CARD 1 */}
          <motion.div
            ref={ref1}
            initial="hidden"
            animate={controls1}
            variants={cardVariants}
            className="rounded-2xl border border-[#F63A0A] overflow-hidden shadow-md hover:shadow-xl w-full sm:w-90"
          >
            <div className="h-60 w-full overflow-hidden">
              <motion.img
                src={media1}
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.05 }}
              />
            </div>

            <motion.div
              variants={contentVariants}
              className="border-t border-[#F63A0A] p-5 flex flex-col gap-4"
            >
              <p className="bg-[#F63A0A] text-white w-fit py-1 px-4 rounded-full text-xs">
                TechCabal
              </p>

              <p className="font-semibold">
                ATC Africa Global Conference (TechX Africa)
              </p>

              <p className="text-xs font-bold">Media Partner</p>
            </motion.div>
          </motion.div>

          {/* CARD 2 */}
          <motion.div
            ref={ref2}
            initial="hidden"
            animate={controls2}
            variants={cardVariants}
            className="rounded-2xl border border-[#F63A0A] overflow-hidden shadow-md hover:shadow-xl w-full sm:w-90"
          >
            <div className="h-60 w-full overflow-hidden">
              <motion.img
                src={media2}
                className="w-full h-full object-cover"
                whileHover={{ scale: 1.05 }}
              />
            </div>

            <motion.div
              variants={contentVariants}
              className="border-t border-[#F63A0A] p-5 flex flex-col gap-4"
            >
              <p className="bg-[#F63A0A] text-white w-fit py-1 px-4 rounded-full text-xs">
                TechEconomy
              </p>

              <p className="font-semibold">
                ATC Africa Global Conference (TechX Africa)
              </p>

              <p className="text-xs font-bold">Media Partner</p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default MediaAbout;
